import './VideoChooserWithImageOrIcons.css';
import React from 'react';
import LazyPicture from '../../atoms/LazyPicture';
import { ReactComponent as IconCheck } from '../../../resources/icons/check-box-white.svg';
const VideoChooserWithImageOrIcons = _ref => {
  let {
    id,
    rtl,
    title,
    svgIcon,
    image,
    isSelected,
    onChange
  } = _ref;
  if (svgIcon.trim().length) {
    return /*#__PURE__*/React.createElement("label", {
      htmlFor: id,
      tabIndex: 0,
      className: `${commonItemStyles} ${rtl ? rtlStyles : ltrStyles} ${iconStyles} ${isSelected ? `${iconStyles}__selected` : ''}`,
      onKeyDown: e => {
        if (e.key === 'Enter') {
          onChange();
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "iconCheckCircle"
    }, /*#__PURE__*/React.createElement(IconCheck, null)), /*#__PURE__*/React.createElement("input", {
      className: "chooser-item__hidden-radio",
      id: id,
      type: "radio",
      tabIndex: -1,
      checked: isSelected,
      onClick: onChange
    }), /*#__PURE__*/React.createElement("div", {
      className: "chooser-item__icon-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "chooser-item__icon",
      "aria-hidden": true,
      dangerouslySetInnerHTML: {
        __html: svgIcon
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "chooser-item__text"
    }, title));
  }
  return image && !image.includes(".svg") ? /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    tabIndex: 0,
    className: `${commonItemStyles} ${rtl ? rtlStyles : ltrStyles} ${imageStyles} ${isSelected ? `${imageStyles}__selected` : ''}`,
    onKeyDown: e => {
      if (e.key === 'Enter') {
        onChange();
      }
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    className: "chooser-item__image"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 991px)",
    srcSet: image
  }), /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: ''
  })), /*#__PURE__*/React.createElement("div", {
    className: "iconCheckCircle"
  }, /*#__PURE__*/React.createElement(IconCheck, null)), /*#__PURE__*/React.createElement("input", {
    className: "chooser-item__hidden-radio",
    id: id,
    type: "radio",
    tabIndex: -1,
    checked: isSelected,
    onClick: onChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "chooser-item__text"
  }, title)) : /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    tabIndex: 0,
    className: `${commonItemStyles} ${rtl ? rtlStyles : ltrStyles} ${imageStyles} ${isSelected ? `${imageStyles}__selected` : ''}`,
    onKeyDown: e => {
      if (e.key === 'Enter') {
        onChange();
      }
    }
  }, /*#__PURE__*/React.createElement("span", null, "please provide image in .png or .jpeg format"), /*#__PURE__*/React.createElement("div", {
    className: "iconCheckCircle"
  }, /*#__PURE__*/React.createElement(IconCheck, null)), /*#__PURE__*/React.createElement("input", {
    className: "chooser-item__hidden-radio",
    id: id,
    type: "radio",
    tabIndex: -1,
    checked: isSelected,
    onClick: onChange
  }));
};
const commonItemStyles = "c1cy2g2e";
const rtlStyles = "r6byqom";
const ltrStyles = "l1ip1fjk";
const iconStyles = "i17pgjf5";
const imageStyles = "i1kn71ce";
VideoChooserWithImageOrIcons.displayName = "VideoChooserWithImageOrIcons";
export { VideoChooserWithImageOrIcons };